import * as yup from "yup";
export const schema = yup.object({
  terms: yup.string().required("accept Terms is required "),
});
